import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';
import '../../App.css';
import '../../css/bootstrap.scss';
import QR_code from "../../images/QR_code.png";
import { Link } from 'react-router-dom';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import lock from "../../images/lock.png";
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import axios from 'axios';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../renderField';
import { connect } from 'react-redux';
import { setEmail, setPassword, setwizardPageNumber, setFaceID } from '../LoginReducer';
import { RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import { AxiosError } from 'axios';
import { compose } from 'redux';
import QRCode from "react-qr-code";
import { useTranslation } from 'react-i18next';

interface FormData { }

interface Props { };

const SignInMultifactorAuth: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const page = useSelector((state: RootState) => state.loginAccount.wizardPageNumber);
    const accessToken = useSelector((state: RootState) => state.loginAccount.accessToken);

    const [qrCode, setQrCode] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [validatedEmpty, setValidatedEmpty] = useState(false);
    const [validatedSuccess, setValidatedSuccess] = useState(false);

    const startLoading = () => {
        setLoading(true);
    };

    const getQRCodeUrl = async () => {
        const qrCodeUrl = await generateTOTP_URL();
        return qrCodeUrl;
    };

    const handleBackBtn = () => {
        dispatch(setwizardPageNumber(page - 1));
    };

    const generateTOTP_URL = async () => {
        try {
            const enableMFA = await axios.post(config.NODE_API_BASE_URL + '/wso2/enableMFA',
                { action: 'INIT' },
                {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                }).catch((reason: AxiosError<{ additionalInfo: string }>) => {
                    if (reason.response!.status != 200) {
                        notifyError("QR failed");
                        setIsSubmitted(false);
                    }
                });

            if (enableMFA?.data.qrCodeUrl) {
                return enableMFA?.data.qrCodeUrl;
            } else {
                return 0;
            }
        } catch (error: any) {
            console.error(error);
            setIsSubmitted(false);
        }
    };

    useEffect(() => {
        getQRCodeUrl().then((qrCodeUrl) => {
            if (qrCodeUrl) {
                const decodedData = atob(qrCodeUrl);
                setQrCode(decodedData);
            } else {
                setIsSubmitted(false);
            }
        });
    }, []);

    const submitForm = async (formValues: FormData) => {
        setIsSubmitted(true);
        startLoading();
        dispatch(setwizardPageNumber(page + 1));
    };

    return (
        <>
            <Header />
            <Container fluid className='min-vh-custom bg-sky'>
                <Row>
                    <Col md={12} className='text-center mt-5'>
                        <br /><br /><br />
                        <img src={lock} width={55} />
                        <h4 className='text-center mt-3 fw-bold'>{t('login.mfa_title')}</h4>

                        <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>
                            <Row className='text-center mt-4'>
                                <Col md={4}></Col>
                                <Col md={4} className='rounded-3 mb-5 bg-white mx-auto' style={{ width: 'fit-content' }}>
                                    <p className='text-secondary mt-2 mb-2'>{t('login.mfa_scan_desc')}</p>
                                    <div>
                                        <QRCode value={qrCode} size={140} />
                                    </div>

                                    <p className='text-black mt-2 fw-bold small'>{t('login.cant_scan')}</p>

                                    <div className='d-flex justify-content-between'>
                                        <div className='mt-2'>
                                            <Link to={''} onClick={handleBackBtn} className="text-primary mb-3 ms-5">{t('common.back')}</Link>
                                        </div>
                                        <div>
                                            <Button type='submit' className="btn btn-dark mt-1 mb-3 me-3 rounded-5 px-4 py-2">{t('common.continue')}</Button>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4}></Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Container>
            <Footer full={true} />
        </>
    );
};

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,
})(SignInMultifactorAuth);

export default connect(null)(form);
